"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var createHelpPostSchema = function createHelpPostSchema(_ref) {
  var _page$seo, _page$seo2, _page$seo3, _page$seo4, _page$seo4$og, _page$seo5, _page$seo5$og, _page$seo5$og$image, _page$seo6, _page$seo6$og, _page$seo6$og$image, _page$author, _page$author2;
  var page = _ref.page;
  if (page.contentType !== 'helpPost' || page.contentType === 'helpPost' && !page.seo) return null;
  if ((_page$seo = page.seo) !== null && _page$seo !== void 0 && _page$seo.schema) return page.seo.schema;
  return _objectSpread(_objectSpread(_objectSpread({
    '@type': 'Article',
    mainEntityOfPage: {
      '@type': 'WebPage'
    },
    headline: page === null || page === void 0 ? void 0 : (_page$seo2 = page.seo) === null || _page$seo2 === void 0 ? void 0 : _page$seo2.title,
    description: page === null || page === void 0 ? void 0 : (_page$seo3 = page.seo) === null || _page$seo3 === void 0 ? void 0 : _page$seo3.description
  }, page !== null && page !== void 0 && (_page$seo4 = page.seo) !== null && _page$seo4 !== void 0 && (_page$seo4$og = _page$seo4.og) !== null && _page$seo4$og !== void 0 && _page$seo4$og.image ? {
    image: {
      '@type': 'ImageObject',
      url: (page === null || page === void 0 ? void 0 : (_page$seo5 = page.seo) === null || _page$seo5 === void 0 ? void 0 : (_page$seo5$og = _page$seo5.og) === null || _page$seo5$og === void 0 ? void 0 : (_page$seo5$og$image = _page$seo5$og.image) === null || _page$seo5$og$image === void 0 ? void 0 : _page$seo5$og$image.src) || '',
      width: page === null || page === void 0 ? void 0 : (_page$seo6 = page.seo) === null || _page$seo6 === void 0 ? void 0 : (_page$seo6$og = _page$seo6.og) === null || _page$seo6$og === void 0 ? void 0 : (_page$seo6$og$image = _page$seo6$og.image) === null || _page$seo6$og$image === void 0 ? void 0 : _page$seo6$og$image.width
    }
  } : {}), page !== null && page !== void 0 && (_page$author = page.author) !== null && _page$author !== void 0 && _page$author.name ? {
    author: {
      '@type': 'Person',
      name: page === null || page === void 0 ? void 0 : (_page$author2 = page.author) === null || _page$author2 === void 0 ? void 0 : _page$author2.name
    }
  } : {}), {}, {
    publisher: {
      '@type': 'Organization',
      name: 'Fettle',
      parentOrganization: {
        name: 'SH:24 C.I.C.',
        '@type': 'Organization'
      }
    },
    datePublished: page === null || page === void 0 ? void 0 : page.createdAt,
    dateModified: page === null || page === void 0 ? void 0 : page.lastUpdated
  });
};
var _default = createHelpPostSchema;
exports["default"] = _default;